export const fmt = (n) =>
  new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(n);

// Ratio de revente indicatif dérivé de l'exemple fourni : 300 € -> jusqu'à 540 € (x1.8)
export const RESALE_FACTOR = 1.8;

export const PACKS = [
  {
    id: "pack_100",
    slug: "pack-decouverte",
    name: "Pack Découverte",
    tagline: "10 produits inclus",
    products: 10,
    price: 100,
    badge: null,
    highlight: false,
    image:
      "https://static.prod-images.emergentagent.com/jobs/86773c59-3614-477d-9c71-250b0d9699a5/images/fe24f2d602c274c15011ac9f18698aa20007e8ee3cda33e584cdffde5b029dd0.jpeg",
    short:
      "La formule accessible pour faire ses premiers pas dans la revente avec une sélection de produits à présenter et à faire découvrir.",
    description:
      "La formule accessible pour faire ses premiers pas dans la revente avec une sélection de produits à présenter et à faire découvrir. Idéale pour tester l'activité à petit budget et se familiariser avec l'univers Ozentya.",
    contains: [
      "10 produits de beauté Ozentya",
      "Une sélection pensée pour être présentée facilement",
      "Un format idéal pour démarrer sans gros investissement",
    ],
    audience:
      "Pour celles et ceux qui veulent découvrir la revente en douceur, avec un premier investissement mesuré.",
    cta: "JE CHOISIS CE PACK",
  },
  {
    id: "pack_150",
    slug: "pack-essentiel",
    name: "Pack Essentiel",
    tagline: "15 produits inclus",
    products: 15,
    price: 150,
    badge: null,
    highlight: false,
    image:
      "https://static.prod-images.emergentagent.com/jobs/86773c59-3614-477d-9c71-250b0d9699a5/images/fe24f2d602c274c15011ac9f18698aa20007e8ee3cda33e584cdffde5b029dd0.jpeg",
    short:
      "Une formule intermédiaire pour découvrir l'univers Ozentya et commencer progressivement à présenter les produits à son entourage et à ses premiers clients.",
    description:
      "Une formule intermédiaire pour découvrir l'univers Ozentya et commencer progressivement à présenter les produits à son entourage et à ses premiers clients. Un bon équilibre entre budget et diversité de produits.",
    contains: [
      "15 produits de beauté Ozentya",
      "Une sélection plus large pour varier vos présentations",
      "Un stock suffisant pour aborder vos premiers clients",
    ],
    audience:
      "Pour celles et ceux qui souhaitent avancer progressivement avec une sélection un peu plus large.",
    cta: "JE CHOISIS CE PACK",
  },
  {
    id: "pack_300",
    slug: "pack-pro",
    name: "Pack Pro",
    tagline: "30 produits inclus",
    products: 30,
    price: 300,
    badge: "⭐ LE PACK COMPLET",
    highlight: true,
    image:
      "https://static.prod-images.emergentagent.com/jobs/86773c59-3614-477d-9c71-250b0d9699a5/images/fe24f2d602c274c15011ac9f18698aa20007e8ee3cda33e584cdffde5b029dd0.jpeg",
    short:
      "Le pack idéal pour celles et ceux qui souhaitent démarrer avec une sélection complète de produits et disposer d'un stock plus important pour développer leurs ventes.",
    description:
      "Le pack idéal pour celles et ceux qui souhaitent démarrer avec une sélection complète de produits et disposer d'un stock plus important pour développer leurs ventes. La formule la plus complète pour vous donner de la marge de manœuvre dès le départ.",
    contains: [
      "30 produits de beauté Ozentya",
      "La sélection la plus complète",
      "Un stock plus important pour développer vos ventes",
    ],
    audience:
      "Pour celles et ceux qui veulent démarrer avec une sélection complète et un stock plus important.",
    cta: "JE CHOISIS LE PACK PRO",
  },
];

export const getPack = (idOrSlug) =>
  PACKS.find((p) => p.id === idOrSlug || p.slug === idOrSlug);

// Gamme de produits Ozentya (contenu officiel du site ozentya.com)
export const PRODUCTS = {
  shampoing_cactus: {
    name: "Shampoing Cactus Ozentya",
    image: "/img/packs/shampoing_cactus.png",
    tagline: "Shampoing restructurant • 250 ml",
    intro:
      "Le shampoing restructurant qui nettoie en douceur, renforce la fibre et prépare le cuir chevelu à la pousse.",
    description:
      "Un shampoing revitalisant spécialement formulé pour les cheveux épais, afro, bouclés, frisés et texturés. Sa formule nettoie le cuir chevelu en douceur tout en renforçant la fibre capillaire, facilite le démêlage et prépare les cheveux aux soins de pousse. Enrichi en extrait de cactus, il hydrate, assouplit et apporte de la brillance.",
    benefits: [
      "Nettoie le cuir chevelu en douceur",
      "Renforce la fibre et réduit la casse",
      "Facilite le démêlage",
      "Hydrate, assouplit et fait briller",
      "Prépare le cuir chevelu aux soins de pousse",
    ],
    forWho: [
      "Cheveux épais, afro, bouclés, frisés ou texturés",
      "Cheveux secs, cassants, colorés ou défrisés",
      "Cheveux en locks",
    ],
    usage:
      "Appliquez sur cheveux mouillés, massez le cuir chevelu 1 à 2 minutes, faites mousser puis rincez abondamment. À utiliser 1 à 2 fois par semaine.",
    ingredients:
      "Aqua, Sodium Lauroyl Oat Amino Acids, Cocamidopropyl Betaine, Glycerin, Aloe Barbadensis Powder, Guar Hydroxypropyltrimonium Chloride, Parfum, Caprylhydroxamic Acid & Caprylyl Glycol, Ricinus Communis Oil, Glycol Distearate & Cocamide MEA, Dimethicone, Sodium Chloride, Retinyl Palmitate, Tocopheryl Acetate, CI 16255, CI 19140, CI 42051.",
  },
  apres_shampoing: {
    name: "Après-Shampoing Ozentya",
    image: "/img/packs/apres_shampoing.jpg",
    tagline: "Démêlage & hydratation",
    intro:
      "L'après-shampoing universel au ricin, karité et jojoba pour des cheveux doux, souples et faciles à démêler.",
    description:
      "Un après-shampoing polyvalent formulé à partir d'un mélange précieux d'huile de ricin, de beurre de karité et d'huile de jojoba. Riche en actifs naturels, il nourrit intensément les longueurs, prend soin des pointes fragiles et facilite le démêlage. Il fait resplendir les écailles capillaires pour une brillance éclatante et une texture fluide et soyeuse.",
    benefits: [
      "Facilite le démêlage sans tirer ni casser",
      "Hydrate et nourrit intensément",
      "Réduit les frisottis et les pointes sèches",
      "Cheveux doux, souples et brillants",
      "Prépare les cheveux aux soins (crème ou masque)",
    ],
    forWho: [
      "Cheveux secs, bouclés, frisés ou crépus",
      "Cheveux emmêlés ou difficiles à coiffer",
      "Cheveux fragiles ou abîmés",
    ],
    usage:
      "Après chaque shampoing, appliquez sur l'ensemble des longueurs, massez délicatement jusqu'aux pointes, laissez agir quelques instants puis rincez abondamment.",
    ingredients:
      "Actifs principaux : huile de ricin (Ricinus Communis Oil), beurre de karité (Butyrospermum Parkii Butter) et huile de jojoba, riches en actifs naturels nourrissants.",
  },
  creme_cactus: {
    name: "Crème Cactus Ozentya",
    image: "/img/packs/creme_cactus.png",
    tagline: "Hydratation & nutrition intense",
    intro:
      "La crème réparatrice qui hydrate, nourrit et protège les cheveux secs et abîmés en profondeur.",
    description:
      "Une crème nourrissante et réparatrice pour tous types de cheveux : elle hydrate, assouplit et protège la fibre capillaire. Idéale pour les cheveux bouclés, frisés, crépus ou abîmés, sa formule riche en actifs naturels répare les cheveux secs et cassants sans les alourdir.",
    benefits: [
      "Hydrate et nourrit en profondeur",
      "Répare les cheveux secs et cassants",
      "Protège contre les agressions extérieures",
      "Rend les cheveux doux, souples et brillants",
      "Facilite le coiffage et le démêlage",
    ],
    forWho: [
      "Cheveux secs, bouclés, frisés ou crépus",
      "Cheveux abîmés ou cassants",
      "Cheveux déshydratés ou colorés",
    ],
    usage:
      "Appliquez une noisette de crème sur cheveux propres et essorés, répartissez sur les longueurs et les pointes. Sans rinçage, en routine quotidienne ou en soin intensif.",
    ingredients:
      "Ricinus Communis Oil, Hydrogenated Soybean Oil, Cera Alba, Fragrance, Aloe Barbadensis Leaf Oil, Gossypium Herbaceum Seed Oil, Butyrospermum Parkii Butter, Macadamia Ternifolia Seed Oil, Cocos Nucifera Fruit Extract, Chamomilla Recutita Flower Extract, Aloe Barbadensis Leaf Extract, Camellia Sinensis Leaf Extract, Cinnamomum Zeylanicum Bark Extract, Acorus Calamus Root Extract, Commiphora Myrrha Resin Extract, Olea Europaea Fruit Oil, Argania Spinosa Kernel Oil, Capsicum, Mentha Piperita Oil, Retinyl Palmitate, Tocopheryl Acetate, Limonene, Linalool, CI 61565.",
  },
  extreme_repouss: {
    name: "Extrême Repouss' Ozentya",
    image: "/img/packs/extreme_repouss.png",
    tagline: "Sérum fortifiant sans rinçage",
    intro:
      "Le sérum expert qui aide à favoriser la pousse et à renforcer les cheveux dès la racine.",
    description:
      "Un sérum capillaire concentré développé pour les cheveux afro, crépus, bouclés, frisés et métissés. Il agit directement sur le cuir chevelu afin de créer les meilleures conditions pour une pousse naturelle, tout en renforçant la fibre. Grâce à ses actifs soigneusement sélectionnés, il aide à revitaliser le cuir chevelu, limiter la casse et obtenir des cheveux plus forts et plus résistants. Les résultats varient selon les personnes et le cycle naturel de croissance.",
    benefits: [
      "Favorise la pousse naturelle des cheveux",
      "Aide à réduire la chute liée à la casse",
      "Renforce les cheveux dès la racine",
      "Hydrate le cuir chevelu et apaise les démangeaisons",
      "Améliore la souplesse et la brillance",
    ],
    forWho: [
      "Pousse lente ou cheveux cassants",
      "Tempes clairsemées, cuir chevelu sec",
      "Cheveux naturels, défrisés, colorés, tressés, en locks ou sous perruque",
    ],
    usage:
      "Appliquez quelques gouttes directement sur le cuir chevelu propre ou sec. Massez délicatement 2 à 3 minutes du bout des doigts. Ne pas rincer. Utilisez quotidiennement, de préférence le soir.",
    ingredients:
      "Glycerin, Methyl Salicylate, Camphor, Menthol, Aqua (Water), Alcohol Denat., Panthenyl Ethyl Ether, Milk Protein, Lactose, Inositol, Acetyl Cysteine, Acetyl Methionine, Sodium Citrate, Citric Acid, CI 42051.",
  },
  masque_supreme: {
    name: "Masque Suprême Ozentya",
    image: "/img/packs/masque_supreme.jpg",
    tagline: "Réparation intense",
    intro:
      "Le masque réparateur intense qui nourrit, fortifie et redonne vie aux cheveux secs et abîmés.",
    description:
      "Un soin profond conçu pour restaurer la fibre capillaire, nourrir intensément et redonner force et douceur aux cheveux fragilisés. Sa texture riche pénètre au cœur de la fibre pour apporter une nutrition durable sans alourdir. Utilisé comme une cure réparatrice hebdomadaire, il restaure l'hydratation, renforce les longueurs et réduit la casse liée au coiffage.",
    benefits: [
      "Nourrit intensément les cheveux secs et abîmés",
      "Aide à réduire la casse",
      "Facilite le démêlage",
      "Redonne brillance, douceur et vitalité",
      "Améliore la définition des boucles",
    ],
    forWho: [
      "Cheveux afro, crépus, bouclés, frisés et métissés",
      "Cheveux secs, cassants ou abîmés",
      "Cheveux colorés ou défrisés (convient dès 3 ans)",
    ],
    usage:
      "Après le shampoing, appliquez sur cheveux essorés, répartissez sur les longueurs et les pointes. Laissez poser 5 à 15 minutes (sous une charlotte ou à chaleur douce), puis rincez abondamment. 1 à 2 fois par semaine.",
    ingredients:
      "Aqua, Cetearyl Alcohol, Behentrimonium Chloride, Butyrospermum Parkii Butter, Cocos Nucifera Oil, Glycerin, Aloe Barbadensis Leaf Juice Powder, Opuntia Ficus-Indica Extract, Hydrolyzed Wheat Protein, Panthenol, Ricinus Communis Seed Oil, Parfum, Phenoxyethanol & Ethylhexylglycerin, Tocopheryl Acetate, Citric Acid, CI 19140, CI 42090.",
  },
};

// Ordre d'affichage de la gamme
export const PRODUCT_KEYS = ["shampoing_cactus", "apres_shampoing", "creme_cactus", "extreme_repouss", "masque_supreme"];

export const getProduct = (key) => PRODUCTS[key];

// Aperçu de la gamme présente dans chaque pack
export const PACK_PREVIEW = ["shampoing_cactus", "apres_shampoing", "creme_cactus", "extreme_repouss", "masque_supreme"];

// Composition détaillée : chaque pack contient un nombre égal des 5 soins de la gamme
export const PACK_COMPOSITION = {
  pack_100: [
    { key: "shampoing_cactus", qty: 2 },
    { key: "apres_shampoing", qty: 2 },
    { key: "creme_cactus", qty: 2 },
    { key: "extreme_repouss", qty: 2 },
    { key: "masque_supreme", qty: 2 },
  ],
  pack_150: [
    { key: "shampoing_cactus", qty: 3 },
    { key: "apres_shampoing", qty: 3 },
    { key: "creme_cactus", qty: 3 },
    { key: "extreme_repouss", qty: 3 },
    { key: "masque_supreme", qty: 3 },
  ],
  pack_300: [
    { key: "shampoing_cactus", qty: 6 },
    { key: "apres_shampoing", qty: 6 },
    { key: "creme_cactus", qty: 6 },
    { key: "extreme_repouss", qty: 6 },
    { key: "masque_supreme", qty: 6 },
  ],
};
